export const DS_FIELDSET_CLASSES = {
  Root: "ds-fieldset",
  Content: "ds-fieldset__content",
  Actions: "ds-fieldset__actions",
  Header: "ds-fieldset__header",
  Toggle: "ds-fieldset__toggle",
  HeaderDivider: "ds-fieldset__header-divider",
  Body: "ds-fieldset__body",
  Border: "ds-fieldset--border",
  Collapsible: "ds-fieldset--collapsible",
  Collapsed: "ds-fieldset--collapsed",
  Horizontal: "ds-fieldset--horizontal",
  Vertical: "ds-fieldset--vertical",
  Legend: "ds-fieldset__legend",
} as const;
